<template>
  <div class="recruits-code-page">
    <div class="box-wrapper qrcode-container" ref="showBoxRef" id="showBox">
      <img :src="bg" style="width: 100%;"/>
      <div class="show-box-wrap">
        <div class="show-box">
          <div class="show-box-title">微信扫一扫<br />录入学员信息</div>
          <div class="show-box-img">
            <img :src="qrcodeImgSrc" />
          </div>
        </div>
      </div>
    </div>
    <div style="position: relative">
      <img :src="qrcodeImgSrc1" v-if="qrcodeImgSrc1" class="haibao"/>
      <div class="info"># 长按保存二维码 #</div>
    </div>
    <div class="use-tips">
      <div class="title">使用提示</div>
      <div class="desc">
        可将你的招生二维码打印、发送或直接展示给家长，家长扫码并填写资料后，系统会自动生成你的招生意向，方便后续进行跟进。
        <span
          v-if="app.permission.op('recruits_clue_add')"
          style="color: var(--c1)"
          @click="
            $router.push({
              name: 'recruitsCode',
            })
          "
          >配置机构信息和扫码录入信息。</span
        >
        <span
          v-else
          style="color: var(--c1)"
          @click="
            $router.push({
              name: 'help-page',
              params: {
                src: 'https://bangzhu.xiaogj.com/yxhelp-list/detail-85.html',
              },
            })
          "
          >如何配置扫码后填写的信息？</span
        >
      </div>
    </div>
    <div ref="qrcode" class="qrcode-container"></div>
  </div>
</template>

<script>
const bg = require('./bg1.png');
import { getHtml2canvas } from "@mlib/js/get-libs/index.js";

export default {
  name: 'recruitsCodePage',
  data() {
    return {
      pageTitle: '招生二维码',
      img: '',
      bg,
      qrcodeImgSrc: '',
      qrcodeImgSrc1: '',
      urlAgr: '',
      url: '',
    };
  },
  computed: {
    ...Vuex.mapState(['userInfo']),
  },
  methods: {
    async getQrCodeImg() {
      this.showLoading();
      let _rsv,
        _rej,
        _pro = new Promise((resolve, reject) => {
          _rsv = resolve;
          _rej = reject;
        });

      const QRCode = await app.libs.getQrCodeJs();
      new QRCode(this.$refs.qrcode, this.url);
      await new Promise(rsv => setTimeout(rsv, 0));

      const qrcodeImg = this.$refs.qrcode.lastElementChild;
      // 安卓下有bug,不会设置src
      const cvs = this.$refs.qrcode.firstElementChild;
      qrcodeImg.src = cvs.toDataURL('image/png');
      qrcodeImg.onload = () => {
        _rsv();
      }
      this.qrcodeImgSrc = cvs.toDataURL('image/png');

      Promise.all([_pro, getHtml2canvas()]).then(res=> {
        html2canvas(document.querySelector('#showBox'), {
          useCORS: true
        }).then(canvas => {
          const imgURL = canvas.toDataURL('image/png')
          // console.log(imgURL)
          this.qrcodeImgSrc1 = imgURL;
        }).finally(()=> {
          this.$toast.clear();
        })
      })
    },
  },
  mounted() {
    this.getQrCodeImg();
  },
  created() { 
    this.urlAgr = `teacherId=${this.userInfo.id}&companyId=${this.userInfo.companyId}`;
    this.url = `${location.origin}/app/simple${location.search}#/recruitsForm?${this.urlAgr}`;
  },
};
</script>

<style lang="scss" scoped>
.recruits-code-page {
  // padding: 12px 16px;
  .box-wrapper {
    background-color: #f7f8fa;
    .show-box-wrap {
      background-color: #f7f8fa;
      margin-top: -100px;
      margin-left: 16px;
      margin-right: 16px;
      z-index: 100;
      position: relative;
      border-radius: var(--radius-md);
      .show-box {
        padding-bottom: calc(var(--gap) * 52);
        border-radius: var(--radius-md);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        background-color: var(--white);
        
        .show-box-title {
          padding: calc(var(--gap) * 20) 0;
          font-weight: 500;
          text-align: center;
        }
        .show-box-img {
          border: calc(var(--gap) * 8) solid #f9f9f9;
          border-radius: var(--radius-md);
          img {
            width: calc(var(--gap) * 209);
            height: calc(var(--gap) * 209);
          }
        }
      }
    }
  }
  .haibao {
    width: 100%;
  }
  .use-tips {
    padding: calc(var(--gap) * 12) calc(var(--gap) * 32) calc(var(--gap) * 32) calc(var(--gap) * 32);
  }
  .title {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
    color: var(--g8);
  }
  .desc {
    margin-top: 8px;
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
    color: var(--g6);
  }
  .info {
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--g6);
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 100%;
    text-align: center;
  }
  .qrcode-container {
    transform: translate3d(-10000px, -10000px, -1px);
    position: absolute;
  }
}
</style>
